function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 26,
  opacity: 0.596,
  rx: 4
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M7.124 14.822l4.23-4.276a.42.42 0 0 1 .594.005.43.43 0 0 1 .005.6l-3.509 3.546h8.71v-7.27c0-.236.19-.427.423-.427.234 0 .423.191.423.428v7.696a.43.43 0 0 1-.124.303.42.42 0 0 1-.3.125H8.445l3.509 3.546a.43.43 0 0 1-.187.721.42.42 0 0 1-.411-.116l-4.231-4.276a.43.43 0 0 1 0-.605z",
  opacity: 0.248
});

var SvgEnter = function SvgEnter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "#D3D8DD",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/enter.42e6ca7d.svg";
export { ForwardRef as ReactComponent };